import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { MessageFlagForm } from "../../../../expert";
import { withi18n } from "../../../../customer/components";
import { createSuggestions } from "../../../utils/AutoCompleteDataUtil";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
import { findSuggestionFromList } from "@limitless/portal";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import MultilineTextField from "@limitless/modern/inputs/multiline-text-field/MultilineTextField";
const MessageFlagDialog = ({
  type,
  onCancel,
  t,
  onSubmitFlagData
}) => {
  const handleFormSubmit = onFormSubmit => {
    onFormSubmit(t);
    onCancel();
  };
  const [hasMaliciousContent, setHasMaliciousContent] = React.useState(false);
  const handleCancel = () => {
    if (hasMaliciousContent) {
      setHasMaliciousContent(true);
    } else {
      setHasMaliciousContent(false);
    }
    onCancel(false);
  };
  return /*#__PURE__*/React.createElement(MessageFlagForm, {
    type: type,
    onSubmitFlagData: onSubmitFlagData
  }, ({
    code,
    body,
    codeList,
    flagAction,
    fieldErrors,
    onCodeChange,
    onBodyChange,
    onFormSubmit,
    isFormInvalid
  }) => {
    const codeSuggestions = createSuggestions(codeList, {
      labelDataKey: "description",
      valueDataKey: "code"
    });
    return /*#__PURE__*/React.createElement(Dialog, {
      open: true,
      onClose: handleCancel,
      id: "confirmExpertAttachment",
      title: flagAction.overlayTitle,
      onCancelClick: handleCancel,
      onOkClick: () => handleFormSubmit(onFormSubmit),
      okDisabled: isFormInvalid || hasMaliciousContent,
      okText: "Finish",
      cancelVariant: "text",
      paperStyle: {
        maxWidth: "470px"
      },
      titleStyle: {
        paddingBottom: 2.5
      }
    }, /*#__PURE__*/React.createElement(DropdownMenu, {
      label: "Reason Code",
      required: true,
      id: "reasonCode",
      placeholder: "Type to search",
      value: code && code.value ? findSuggestionFromList(codeSuggestions, {
        value: code.value
      }) : null,
      options: codeSuggestions,
      onChange: (e, code) => onCodeChange(code)
    }), /*#__PURE__*/React.createElement(Grid, {
      sx: {
        paddingTop: 2
      }
    }, /*#__PURE__*/React.createElement(MultilineTextField, {
      id: `${flagAction.reasonCodeName.toLowerCase()}Input`,
      label: flagAction.inputPlaceholder,
      onChange: event => onBodyChange(event.target.value),
      type: "textarea",
      onMaliciousDetected: setHasMaliciousContent,
      multiline: true,
      rows: 1,
      value: body.value,
      fullWidth: true,
      placeholder: "Type here",
      required: true,
      error: fieldErrors.body ? true : false,
      errorText: fieldErrors.body
    })));
  });
};
const styles = theme => ({
  container: {
    paddingBottom: 8
  },
  overflow: {
    overflowY: "unset"
  },
  dialog: {
    paddingBottom: 0
  },
  fieldContainer: {
    flexDirection: "column",
    padding: 8,
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: theme.background.default
  },
  inputWrapper: {
    width: "100%",
    marginTop: 16
  }
});
export default withStyles(styles)(withi18n(MessageFlagDialog));
MessageFlagDialog.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  type: PropTypes.string,
  onSubmitFlagData: PropTypes.func
};